import React from 'react';
import PropTypes from 'prop-types';

export default function InputHoc(props) {
  const {
    style, classes, name, selectProps,
    id, Component, className, onKeyUp,
    onChange, placeholder, autoFocus, type, value, disabled
  } = props;
  // becomes controlled component as value get passed from props
  const valueProp = value || value === '' ? { value } : {};
  return (
    <Component
      id={id}
      className={className}
      classes={classes}
      style={style}
      onChange={onChange}
      placeholder={placeholder}
      autoFocus={autoFocus}
      name={name}
      type={type}
      onKeyUp={onKeyUp}
      disabled={disabled}
      {...valueProp}
      {...selectProps}
    />
  );
}

InputHoc.propTypes = {
  style: PropTypes.object,
  classes: (props, propName, componentName) => {
    const classProp = Object.keys(props[propName]) || {};
    for (let index = 0; index < classProp.length; index += 1) {
      if (['input'].indexOf(classProp[index]) === -1) {
        return new Error(
          `Invalid prop '${propName}' supplied to ${componentName}. Validation failed.`
        );
      }
    }
    return false;
  },
  Component: PropTypes.func.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  selectProps: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])
};

InputHoc.defaultProps = {
  style: {},
  classes: {},
  id: '',
  className: '',
  onChange: () => {},
  onKeyUp: () => {},
  placeholder: '',
  autoFocus: false,
  name: '',
  value: false,
  type: 'text',
  selectProps: {},
  disabled: false
};



// WEBPACK FOOTER //
// ./src/widgets/Input/Variants/InputHoc.jsx